import {
  GLOBAL_COLOR_CANVAS_DEFAULT_DARK,
  GLOBAL_COLOR_CANVAS_DEFAULT_LIGHT,
  GLOBAL_COLOR_TYPOGRAPHY_COPY_DEFAULT_DARK,
  GLOBAL_COLOR_TYPOGRAPHY_COPY_DEFAULT_LIGHT,
} from '@oneaudi/unified-web-common';
import type { CustomTheme } from '../@types/theme';
import {
  SYS_COLOR_CANVAS_200_DARK,
  SYS_COLOR_CANVAS_200_LIGHT,
  SYS_COLOR_TEXT_COPY_DEFAULT_DARK,
  SYS_COLOR_TEXT_COPY_DEFAULT_LIGHT,
} from '@oneaudi/unified-web-alpha-common';

const colorsLight = {
  colorCanvasDefault: process.env.IS_LEGACY
    ? GLOBAL_COLOR_CANVAS_DEFAULT_LIGHT
    : SYS_COLOR_CANVAS_200_LIGHT,
  colorCopyDefault: process.env.IS_LEGACY
    ? GLOBAL_COLOR_TYPOGRAPHY_COPY_DEFAULT_LIGHT
    : SYS_COLOR_TEXT_COPY_DEFAULT_LIGHT,
};

const colorsDark = {
  colorCanvasDefault: process.env.IS_LEGACY
    ? GLOBAL_COLOR_CANVAS_DEFAULT_DARK
    : SYS_COLOR_CANVAS_200_DARK,
  colorCopyDefault: process.env.IS_LEGACY
    ? GLOBAL_COLOR_TYPOGRAPHY_COPY_DEFAULT_DARK
    : SYS_COLOR_TEXT_COPY_DEFAULT_DARK,
};

export const lightTheme: CustomTheme = {
  name: 'light',
  colors: colorsLight,
  invertedColors: colorsDark,
};

export const darkTheme: CustomTheme = {
  name: 'dark',
  colors: colorsDark,
  invertedColors: colorsLight,
};
